import { withTimeout } from '@app/utils/wait-until-timeout'

export async function waitForLiveInputsInitialization(
  timeout: number
): Promise<void> {
  let unsubscribe: () => void = () => {}

  try {
    await withTimeout<[], boolean>(
      () =>
        new Promise((resolve) => {
          const resolver = (): void => {
            resolve(true)
          }
          window.eventHub.$on('sf-live-inputs:initialized', resolver)
          unsubscribe = (): void =>
            window.eventHub.$off('sf-live-inputs:initialized', resolver)
        }),
      timeout
    )()
  } catch (err) {
    throw new Error('Live inputs did not initialize in time')
  } finally {
    if (unsubscribe) {
      unsubscribe()
    }
  }
}
